import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/miki_ihara_logo.svg'
import _imports_1 from '@/assets/img/nav-history.svg'
import _imports_2 from '@/assets/img/nav-about.svg'
import _imports_3 from '@/assets/img/nav-introduction.svg'
import _imports_4 from '@/assets/img/nav-access.svg'
import _imports_5 from '@/assets/img/nav-link.svg'
import _imports_6 from '@/assets/img/link-telephone.svg'
import _imports_7 from '@/assets/img/link-privacy.svg'


const _hoisted_1 = { class: "nav-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", null, [
        _createVNode(_component_router_link, { to: { name: 'home' } }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              class: "nav-title",
              src: _imports_0,
              alt: "三木・伊原法律特許事務所"
            }, null, -1)
          ])),
          _: 1,
          __: [0]
        })
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'history' } }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "事務所の沿革",
                class: "nav-el-img"
              }, null, -1)
            ])),
            _: 1,
            __: [1]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'about' } }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "業務内容",
                class: "nav-el-img"
              }, null, -1)
            ])),
            _: 1,
            __: [2]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'introduction' } }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: _imports_3,
                alt: "弁護士・弁理士紹介",
                class: "nav-el-img"
              }, null, -1)
            ])),
            _: 1,
            __: [3]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'access' } }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("img", {
                src: _imports_4,
                alt: "アクセス",
                class: "nav-el-img"
              }, null, -1)
            ])),
            _: 1,
            __: [4]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'link' } }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createElementVNode("img", {
                src: _imports_5,
                alt: "リンク",
                class: "nav-el-img"
              }, null, -1)
            ])),
            _: 1,
            __: [5]
          })
        ])
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("address", null, [
        _createElementVNode("a", { href: "tel:0752563068" }, [
          _createElementVNode("img", { src: _imports_6 })
        ])
      ], -1)),
      _createVNode(_component_router_link, {
        class: "link-privacy",
        to: { name: 'privacy-policy' }
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createElementVNode("img", {
            src: _imports_7,
            alt: "プライバシーポリシー",
            class: "nav-el-privacy"
          }, null, -1)
        ])),
        _: 1,
        __: [6]
      })
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("footer", null, null, -1))
  ]))
}